import { Button } from '@mui/material';
import styled from 'styled-components';

export const ButtonStato = styled(Button)`
  border-radius: 17px !important;
`;
